export const createPinchingAssetCookieKey = (meetingID: string, startTime: string) => {
  return `pinchingAsset:${meetingID}:${startTime}`;
};
